import { render } from "./CourseUpdateSubpage.vue?vue&type=template&id=9134dc8a&scoped=true"
import script from "./CourseUpdateSubpage.vue?vue&type=script&lang=js"
export * from "./CourseUpdateSubpage.vue?vue&type=script&lang=js"

import "./CourseUpdateSubpage.vue?vue&type=style&index=0&id=9134dc8a&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9134dc8a"]])

export default __exports__